import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { adminApi } from '../api/AdminApi';
import { UPDATE_AUTHENTICATION_METHOD } from '../actions/actionTypes';
import {
  updateAuthMethodDone,
  updateAuthMethodError,
  updateAuthMethodLoading,
  updateAuthMethodSuccess
} from '../actions/authentication';

export function* watchUpdateAuthMethodSaga () {
  yield takeLatest(UPDATE_AUTHENTICATION_METHOD, updateAuthMethodSaga);
}

export function* updateAuthMethodSaga ({ tenantId, method, samlUrl, samlFile }) {
  try {
    yield put(updateAuthMethodLoading());
    const tenant = yield call(adminApi.updateAuthMethod, tenantId, method, samlUrl, samlFile);
    yield put(updateAuthMethodSuccess(tenant));
  } catch (error) {
    yield put(updateAuthMethodError(error));
  } finally {
    yield put(updateAuthMethodDone());
  }
}

export default [
  fork(watchUpdateAuthMethodSaga)
];
